module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0090.png.cb196c0e.jpg";